import { DecimalPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import {
    AfterViewInit,
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    input,
    ViewEncapsulation,
} from '@angular/core';
import { RouterLinkDirective } from '@hyundai/ng-common-lib';
import { InputSelectComponent, M000C010ImageComponent } from '@hyundai/ui';
import SearchAboButtonComponent from '../search-abo/search-abo-button/search-abo-button.component';
import QuickSearchBase from './quick-search.base';

@Component({
    selector: 'lib-quick-search',
    standalone: true,
    imports: [
        RouterLinkDirective,
        DecimalPipe,
        InputSelectComponent,
        NgTemplateOutlet,
        M000C010ImageComponent,
        NgClass,
        SearchAboButtonComponent,
    ],
    templateUrl: './quick-search.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./quick-search.component.scss'],
})
export class QuickSearchComponent extends QuickSearchBase implements AfterViewInit {
    backgroundImageUrl = input({
        '2xl': 'https://eu-central-1-shared-euc1-02.graphassets.com/cluk4akwq0hkd07w15cu50y0w/cmrd9u0ryrli307vwpezbp8kw',
        lg: 'https://eu-central-1-shared-euc1-02.graphassets.com/cluk4akwq0hkd07w15cu50y0w/cmrd9u0qar5p306w2g3naobx4',
        md: 'https://eu-central-1-shared-euc1-02.graphassets.com/cluk4akwq0hkd07w15cu50y0w/cmretkg5imwyd08vxn3qsyn5d',
        mobile: 'https://eu-central-1-shared-euc1-02.graphassets.com/cluk4akwq0hkd07w15cu50y0w/cmrdd6yyn56ff07w8q8qype8m',
    });
    altBackgroundImage = input(
        'Blick in den Innenraum eines Hyundai IONIQ 3 mit Sportsitzen und einer entspannt sitzenden Person auf dem Beifahrersitz mit einem Getränkebecher in der Hand.',
    );

    hasKeyPromotionBanner = input(false, { transform: booleanAttribute });
}
